import * as propTypesModule from "../../node_modules/prop-types/index.js";

const PropTypes =
  (propTypesModule as { default?: unknown }).default ??
  propTypesModule;

export default PropTypes;
